import {useCallback, useEffect, useState} from 'react';
import {getStarRankData} from '@/api/starrank/starrank';
import StarRankMobileLayout from '@/components/starrank/mobile/StarRankMobileLayout';
import StarRankPcLayout from '@/components/starrank/pc/StarRankPcLayout';
import {Helmet} from 'react-helmet';
import throwToast from '@/utils/ui/toast';
import MyPlusApi from '@/api/main/my-plus';
import {goLogin, isLogin} from '@/utils/main';
import {getDeviceType} from '@/utils';
import {StarrankT} from '@/utils/i18n/starrank';

/**
 * 별별랭킹 서비스 Root
 * @returns
 */
const StarRank = () => {
  // API 호출, 상태 관리 등 각종 비즈니스 로직 처리

  const [starRankBestDataCnt, setStarRankBestDataCnt] = useState(0);
  const [starRankBestData, setStarRankBestData] = useState([]);
  const [starRankListData, setStarRankListData] = useState([]);

  const [thumbClass, setThumbClass] = useState('');

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      try {
        /** 별별랭킹 데이터 요청 */
        const starRankData = await getStarRankData(4);

        setStarRankBestDataCnt(starRankData.bestDataCnt);
        setStarRankBestData(starRankData.bestData);
        setStarRankListData(starRankData.themeData);
      } catch (error) {
        // Note. 에러 발생 시 Sentry 로그는 API Core에서 전송됨
        setStarRankBestDataCnt(0);
        setStarRankBestData([]);
        setStarRankListData([]);
      }
      setIsLoading(false);
    })();
  }, []);

  /**
   * 나중에보기 버튼 클릭 시
   * @param {*} broadcastId
   */
  const onClickLaterViewBtn = useCallback(async (broadcastId) => {
    if (!isLogin()) {
      goLogin();
      return;
    }

    try {
      const {result, message, data} = await MyPlusApi.setLaterView(
        'LIVE',
        broadcastId,
      );
      throwToast(message);
    } catch (error) {
      const {message} = error.response.data;
      throwToast(message);
    }
  }, []);

  /**
   * PC / 모바일 공통 프로퍼티
   */
  const commonProps = {
    starRankBestData,
    starRankBestDataCnt,
    starRankListData,
    onClickLaterViewBtn,
    thumbClass,
    isLoading,
  };

  return (
    <>
      <Helmet>
        <title>{StarrankT('별별랭킹 - SOOP')}</title>
        <meta
          name='keywords'
          content={StarrankT(
            'SOOP, 스트리머, 랭킹, 순위, 인기 스트리머, 인기 순위',
          )}
        />
        <meta
          name='description'
          content={StarrankT('SOOP 스트리머들의 주제별 순위를 확인해보세요.')}
        />
      </Helmet>
      {/* 사용자의 모바일 기기 / PC 접속 여부에 따라 컴포넌트 분기 처리 */}
      {getDeviceType() === 'mobile' ? (
        <>
          <StarRankMobileLayout {...commonProps} />
        </>
      ) : (
        <>
          <StarRankPcLayout {...commonProps} />
        </>
      )}
    </>
  );
};

export default StarRank;
